const Alert = ({ ...props }) => {
    return (
        <svg
            width="25"
            height="25"
            preserveAspectRatio="none"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x="1.49495"
                y="1.00547"
                width="23"
                height="23"
                rx="11.5"
                transform="rotate(0.630736 1.49495 1.00547)"
                stroke="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.7575 7.37109L11.978 7.37109C11.955 7.37109 11.9322 7.37371 11.9109 7.3788C11.8896 7.38389 11.8703 7.39135 11.8541 7.40075C11.8378 7.41015 11.8249 7.42132 11.8161 7.4336C11.8073 7.44588 11.8027 7.45905 11.8027 7.47235L11.8027 14.2698C11.8027 14.2967 11.8212 14.3224 11.8541 14.3414C11.8869 14.3604 11.9315 14.3711 11.978 14.3711L13.7575 14.3711C13.8039 14.3711 13.8485 14.3604 13.8814 14.3414C13.9143 14.3224 13.9327 14.2967 13.9327 14.2698L13.9327 7.47236C13.9327 7.4455 13.9143 7.41974 13.8814 7.40075C13.8485 7.38176 13.8039 7.37109 13.7575 7.37109ZM11.978 15.8916L13.7575 15.8916C13.8543 15.8916 13.9327 15.9492 13.9327 16.0202L13.9327 17.763C13.9327 17.834 13.8543 17.8916 13.7575 17.8916L11.978 17.8916C11.8812 17.8916 11.8027 17.834 11.8027 17.763L11.8027 16.0202C11.8027 15.9492 11.8812 15.8916 11.978 15.8916Z"
                fill="black"
            />
        </svg>
    )
}

export default Alert
